module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-vehicle-slot-avaiability"
  }, [(_vm.availability.length) ? _c('div', {
    staticClass: "time-slots",
    style: (_vm.showRows)
  }, [_vm._l((_vm.availability), function(timeSlot, index) {
    return [_c('label', [_c('ToggleableButton', {
      key: timeSlot.start_timestamp,
      staticClass: "small",
      class: {
        'fake-selection': _vm.fakeSelection(index)
      },
      style: ({}),
      attrs: {
        "disabled": !timeSlot.available,
        "selectable": _vm.selectable
      },
      nativeOn: {
        "click": function($event) {
          return _vm.checkIndex($event)
        }
      },
      model: {
        value: (timeSlot.selected),
        callback: function($$v) {
          _vm.$set(timeSlot, "selected", $$v)
        },
        expression: "timeSlot.selected"
      }
    }, [_vm._v(_vm._s(_vm.formatUnix(timeSlot.end_timestamp)))])], 1), (_vm.isStartOfDay(timeSlot.end_timestamp)) ? _c('div', {
      staticClass: "grid-break"
    }, [_c('span', [_vm._v(_vm._s(_vm.timeBreak(timeSlot.end_timestamp)) + ", " + _vm._s(_vm.$dateFormat(timeSlot.end, 'DD MMM YYYY')))])]) : _vm._e()]
  })], 2) : _vm._e(), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "button-group"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v("Load more")])])]), (_vm.selectable) ? _c('div', {
    staticClass: "row columns"
  }, [_vm._t("default"), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.selectionValid,
      "dark": _vm.selectionValid,
      "light": true
    },
    on: {
      "click": function($event) {
        return _vm.$emit('slotsSelected', _vm.selectedSlots)
      }
    }
  }, [_vm._v(_vm._s(_vm.selectionValid ? _vm.extend ? 'Extend ' : 'Book' : 'Select range'))])], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b812e00!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/VehicleAvailability.vue
// module id = 2253
// module chunks = 1